<template>
  <v-dialog
    :max-width="maxWidth"
    v-bind="$attrs"
    v-on="$listeners">
    <v-card>
      <v-card-title class="headline">
        <h5>{{ title }}</h5>
      </v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="default darken-1"
          @click="$emit('cancel')">
          {{ cancelText }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!!otherText"
          retain-focus-on-click
          color="primary"
          @click="$emit('other')">
          {{ otherText }}
        </v-btn>
        <v-btn
          retain-focus-on-click
          color="error darken-2"
          @click="$emit('ok')">
          {{ okText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    cancelText: {
      type: String,
      default: 'いいえ',
    },
    okText: {
      type: String,
      default: 'はい',
    },
    otherText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '確認',
    },
    maxWidth: {
      type: Number,
      default: 320,
    },
  },
}
</script>

<style scoped>

</style>
